import { Button } from '@/components/Button';
import { Form } from '@/components/Form';
import { Flex } from '@/components/Grid';
import { Heading } from '@/components/Heading';
import { type AdCategoryItemType, type AdType } from '@/resource/ad';
import { SetState } from '@/util/types';
import { CancelLink } from './CancelLink';

type Props = {
  adType: AdType;
  isValid: boolean;
  category: AdCategoryItemType | null;
  categories: AdCategoryItemType[];
  setCategory: SetState<AdCategoryItemType | null>;
  onBack: () => void;
  onNext: () => void;
};

export function SelectCategoryForm({
  adType,
  isValid,
  category,
  categories,
  setCategory,
  onBack,
  onNext,
}: Props) {
  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        onNext();
      }}
    >
      <Flex dir="column" gap={4}>
        <Heading visualLevel={3} align="center">
          Selecteer een categorie
        </Heading>

        <Flex wrap>
          {categories.map((cat) => (
            <Button
              key={cat.id}
              icon={cat.icon}
              shape="square"
              theme={category?.id === cat.id ? 'primary' : 'secondary'}
              onClick={() => {
                setCategory(cat);
              }}
            >
              {cat.name}
            </Button>
          ))}
        </Flex>

        <Flex justify="space-between">
          <Button
            theme="secondary"
            icon="chevron_left_narrow"
            iconSize={2}
            onClick={onBack}
          >
            Terug
          </Button>
          <Button
            type="submit"
            disabled={!isValid}
            icon="chevron_right_narrow"
            iconPosition="right"
            iconSize={2}
          >
            Naar foto
          </Button>
        </Flex>

        <CancelLink confirm adType={adType} />
      </Flex>
    </Form>
  );
}
